(function () {
  var cartUpdateQuantityEls = document.querySelectorAll(".cart__table-cell--quantity [data-item-update]");
  cartUpdateQuantityEls.forEach((cartUpdateQuantityEl) => {
    var lineItemKey = cartUpdateQuantityEl.dataset.id;
    var lineItemIndexInCart = cartUpdateQuantityEl.dataset.cartIndex;
    var quantityEl = document.querySelector("[data-quantity-field][data-id='" + lineItemKey + "']");

    cartUpdateQuantityEl.addEventListener("click", function () {
      var quantity = quantityEl.value;
      window.location.href = "/cart/change?line=" + lineItemIndexInCart + "&quantity=" + quantity;
    });
  });
})();

window.openFaqFromFaqTopSectionLink = function (id) {
  var liEl = document.getElementById(id);
  var top = liEl.getBoundingClientRect().top + window.pageYOffset - 60;
  var isOpened = liEl.classList.contains("is-expanded");
  window.scrollTo({ top: top, behavior: "smooth" });

  if (!isOpened) {
    setTimeout(function () {
      liEl.querySelector("a").click();
    }, 800);
  }
};

window.scrollToId = function (id) {
  var liEl = document.getElementById(id);
  var top = liEl.getBoundingClientRect().top + window.pageYOffset - 60;
  window.scrollTo({ top: top, behavior: "smooth" });
};

// Rice-Burger専門店
let fadeInTarget = document.querySelectorAll(".js-fadeIn");
for (let i = 0; i < fadeInTarget.length; i++) {
  window.addEventListener("scroll", function () {
    const rect = fadeInTarget[i].getBoundingClientRect().top;
    const scroll = window.pageYOffset;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    if (scroll > offset - windowHeight + 150) {
      fadeInTarget[i].classList.add("scroll-in");
    } else {
      fadeInTarget[i].classList.remove("scroll-in");
    }
  });
}

// product description accordion
const accordionEls = document.querySelectorAll(".product__description .accordion");
accordionEls.forEach((accordionEl) => {
  const titleEl = accordionEl.querySelector(".title");

  function toggle() {
    accordionEl.classList.toggle("opened");
    setHeights();
  }

  function setHeights() {
    const height = accordionEl.classList.contains("opened") ?
      accordionEl.dataset.contentHeight :
      accordionEl.dataset.titleHeight;
    accordionEl.style.maxHeight = height + "px";
  }

  function recalculateHeights() {
    accordionEl.style.maxHeight = "initial";
    accordionEl.dataset.titleHeight = titleEl.getBoundingClientRect().height;
    accordionEl.dataset.contentHeight = accordionEl.getBoundingClientRect().height;
    setHeights();
  }

  titleEl.addEventListener("click", toggle);
  window.addEventListener("resize", recalculateHeights);
  recalculateHeights();
});